'use strict';

const i18n = require('i18next');
const Mn = require('backbone.marionette');
const Template = require('system/ui/template/modal/commit-comment.hbs');
const MarkdownWriterView = require('common/ui/view/markdown/writer');

module.exports = Mn.View.extend({
    template: Template,
    events: {
        'click .close': 'remove'
    },
    ui: {
        'commitMessageWriterContainer': '.commit-message'
    },

    initialize: function() {
        this._message = '';
    },

    onRender: function() {
        // markdown writer
        const writer = new MarkdownWriterView({
            project: this.getOption('project'),
            markdown: '',
            useDataContentSelector: false,
            placeholder: i18n.t('diagram:commitComment.placeholder'),
            rows: 8,
        });
        this.$('.commit-message').append(writer.render().$el);
        this.listenTo(writer, 'change', (desc) => {
            this._message = desc;
        });

        return this;
    },

    commit: function() {
        const oldContext = this.getOption('context');
        const project = this.getOption('project');
        // TODO: oldContext からは DataSetのKeyが取得できないので、ここで組み立てる
        const datasetKey = `${project.getMasterBranchKey()}/Diagram:${oldContext.diagramId}`;
        const commentBody = this._message;
        const hasCommitComment = commentBody !== '';
        const payload = {
            'project': project
        };

        if (hasCommitComment) {
            // Comment を雑に Hash で作っているけれど、本当は Entity Object にするべきなんだろう...
            payload['comment'] = {
                'body': commentBody,
                'relatedKeys': [datasetKey]

            };
        }

        this.trigger('commit', payload);
    }
});



// WEBPACK FOOTER //
// ./system/ui/view/modal/commit-comment.js